/**
 * Protected Route Component - Clerk Integration
 *
 * Features:
 * - Route protection using Clerk authentication
 * - Auto-redirect to login if not authenticated
 * - Preserve intended destination
 * - Loading state handling
 * - Simplified role checks (can be extended with Clerk metadata)
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';

interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isSignedIn, isLoaded } = useAuth();
  const location = useLocation();

  // Show loading state while checking authentication
  if (!isLoaded) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isSignedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // All checks passed, render children
  return children;
};

export default ProtectedRoute;
